module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tableFixed",
    attrs: {
      "id": "tableFixed"
    }
  }, [_c('table', {
    staticClass: "table no-margin"
  }, [_c('thead', [_c('tr', _vm._l((_vm.columns), function(column, index) {
    return _c('VueHeader', {
      key: index,
      attrs: {
        "sort": _vm.sort,
        "column": column,
        "options": _vm.options
      },
      on: {
        "click": _vm.headerClick
      }
    })
  }), 1)]), _vm._v(" "), (_vm.scrollInfinite) ? _c('tbody', {
    directives: [{
      name: "infinite-scroll",
      rawName: "v-infinite-scroll",
      value: (_vm.loadMore),
      expression: "loadMore"
    }],
    staticClass: "table no-margin bodyInfinite",
    attrs: {
      "infinite-scroll-disabled": "busy",
      "infinite-scroll-distance": "50"
    }
  }, _vm._l((_vm.pageRows), function(row, index) {
    return (_vm.hasData) ? _c('VueRow', {
      key: index,
      attrs: {
        "row": row,
        "columns": _vm.columns,
        "options": _vm.options
      },
      on: {
        "click": _vm.rowClick
      }
    }) : _vm._e()
  }), 1) : _vm._e(), _vm._v(" "), (!_vm.scrollInfinite) ? _c('tbody', {
    staticClass: "table no-margin"
  }, [_vm._l((_vm.pageRows), function(row, index) {
    return (_vm.hasData) ? _c('VueRow', {
      key: index,
      attrs: {
        "row": row,
        "columns": _vm.columns,
        "options": _vm.options
      },
      on: {
        "click": _vm.rowClick
      }
    }) : _vm._e()
  }), _vm._v(" "), (!_vm.hasData && !_vm.isLoading) ? _c('tr', [_c('td', {
    staticStyle: {
      "vertical-align": "top!important"
    },
    attrs: {
      "colspan": _vm.columns.length
    }
  }, [_c('va-alert', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "warning"
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('i', {
    staticClass: "icon fa fa-warning"
  }), _vm._v(" No Data Found !\n            ")])])], 1)]) : _vm._e(), _vm._v(" "), (_vm.hasData && _vm.isLastPage) ? _c('tr', [_c('td', {
    staticStyle: {
      "height": "100%!important"
    },
    attrs: {
      "colspan": _vm.columns.length
    }
  })]) : _vm._e(), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "is-full-page": _vm.isFullpage
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })], 2) : _vm._e(), _vm._v(" "), _c('tfoot', {
    staticClass: "table no-margin"
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "border": "none",
      "padding": "0px"
    },
    attrs: {
      "colspan": _vm.columns.length
    }
  }, [_c('div', {
    staticClass: "box-footer clearfix"
  }, [(_vm.hasPaging) ? _c('div', {
    staticClass: "box-tools pull-left"
  }, [_c('ul', {
    staticClass: "pagination pagination-sm inline"
  }, [_c('li', {
    staticClass: "noClick"
  }, [_c('a', {
    attrs: {
      "href": "#",
      "disabled": "disabled"
    }
  }, [_vm._v("Total rows: " + _vm._s(_vm.rows.length))])])])]) : _vm._e(), _vm._v(" "), (_vm.info) ? _c('div', {
    staticClass: "box-tools pull-left"
  }, _vm._l((_vm.info), function(item) {
    return _c('div', {
      staticClass: "pull-left divInfo"
    }, [_c('i', {
      class: [item.icon]
    }), _vm._v(" " + _vm._s(item.label))])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.hasPaging) ? _c('div', {
    staticClass: "box-tools"
  }, [_c('div', {
    staticClass: "box-tools pull-left",
    staticStyle: {
      "padding": "0px 10px"
    }
  }, [_c('div', {
    staticClass: "pull-left divInfo"
  }, [_vm._v("Rows per page:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pageSize),
      expression: "pageSize"
    }],
    staticClass: "form-control",
    staticStyle: {
      "padding-left": "0px",
      "width": "70px",
      "height": "30px",
      "border-radius": "5px",
      "color": "#666",
      "background-color": "#fafafa"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.pageSize = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.pageSizes), function(size, index) {
    return _c('option', {
      domProps: {
        "value": size
      }
    }, [_vm._v(_vm._s(size))])
  }), 0)]), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.totalPages > 1),
      expression: "totalPages>1"
    }],
    staticClass: "pagination pagination-sm inline"
  }, [_c('li', [_c('a', {
    staticClass: "noselect",
    on: {
      "click": function($event) {
        return _vm.nextPage(-1)
      }
    }
  }, [_vm._v("«")])]), _vm._v(" "), _vm._l((_vm.filteredTotalPages), function(page) {
    return _c('li', [_c('a', {
      class: ['noselect', page === _vm.currentPage ? 'activePage' : ''],
      on: {
        "click": function($event) {
          _vm.currentPage = page
        }
      }
    }, [_vm._v(_vm._s(page))])])
  }), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "noselect",
    on: {
      "click": function($event) {
        return _vm.nextPage(1)
      }
    }
  }, [_vm._v("»")])])], 2)]) : _vm._e()])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-852cff30!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Table/DataTable.vue
// module id = 733
// module chunks = 0